<div class="holder searching-internet" [class.searching]="searching">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    style="enable-background: new 0 0 400 400"
    xml:space="preserve"
  >
    <style type="text/css">
      .no-network-st0 {
        fill: #ffffff;
        stroke: #f26522;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
      }

      .no-network-st1 {
        fill: #eec4af;
      }

      .no-network-st2 {
        fill: #eec4af;
        stroke: #f26522;
        stroke-width: 4;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
      }

      .no-network-st3 {
        fill: #ffffff;
        stroke: #f26522;
        stroke-width: 4;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
      }
    </style>
    <g>
      <polygon
        class="no-network-st0 delay2"
        points="143.5,19.2 135.1,22.2 130.4,9.2 113.6,15.3 121.1,36.1 129.5,33 136.2,51.5 	"
      />
      <polygon
        class="no-network-st0 delay1"
        points="152.2,211.7 143.9,208.7 148.6,195.6 131.8,189.5 124.3,210.3 132.6,213.4 125.9,231.8 	"
      />
      <g>
        <g>
          <path
            class="no-network-st1"
            d="M236,328.3c24,13.9,24.1,36.3,0.3,50.2c-23.8,13.9-62.6,13.9-86.6,0c-24-13.9-24.1-36.3-0.3-50.2
                  C173.2,314.4,212,314.4,236,328.3z"
          />
        </g>
        <g>
          <path
            class="no-network-st2"
            d="M145.6,346.3c0,7,4.7,14,14,19.4c18.5,10.7,48.4,10.7,66.8,0c9.2-5.3,13.8-12.4,13.7-19.4v-12.9h-94.5
                  L145.6,346.3z"
          />
          <g>
            <path
              class="no-network-st3"
              d="M226.2,314.1c18.5,10.7,18.6,28,0.2,38.7c-18.4,10.7-48.3,10.7-66.8,0c-18.5-10.7-18.6-28-0.2-38.7
                      C177.7,303.4,207.6,303.4,226.2,314.1z"
            />
          </g>
        </g>
        <g>
          <path
            class="no-network-st2"
            d="M160,329.2c0,4.9,3.3,9.7,9.7,13.5c12.9,7.4,33.6,7.4,46.4,0c6.4-3.7,9.6-8.6,9.5-13.5v-12.9H160L160,329.2z
                  "
          />
          <g>
            <path
              class="no-network-st3"
              d="M216,302.8c12.9,7.4,12.9,19.5,0.1,26.9c-12.8,7.4-33.6,7.4-46.4,0c-12.9-7.4-12.9-19.5-0.2-26.9
                      C182.3,295.4,203.1,295.4,216,302.8z"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          class="no-network-st2"
          d="M184.8,315.3c0,1.2,0.8,2.4,2.4,3.3c3.2,1.8,8.3,1.8,11.4,0c1.6-0.9,2.4-2.1,2.3-3.3V113.2h-16.1L184.8,315.3
              z"
        />
      </g>
      <g>
        <g>
          <circle class="no-network-st3 drop" cx="192.9" cy="109.9" r="24.6" />
        </g>
      </g>
      <g>
        <g>
          <g>
            <path
              class="no-network-st2 opacityLoop delay2"
              d="M276.4,169.1c32.7-32.7,32.7-85.9,0-118.5L288,39c18.9,18.9,29.3,44,29.3,70.8c0,26.8-10.4,51.9-29.3,70.8
                      L276.4,169.1z"
            />
            <path
              class="no-network-st2 opacityLoop delay1"
              d="M254.7,147.4c20.7-20.7,20.7-54.4,0-75.2l11.6-11.6c27.1,27.1,27.1,71.2,0,98.3L254.7,147.4z"
            />
            <path
              class="no-network-st2 opacityLoop"
              d="M233,125.7c4.2-4.2,6.6-9.9,6.6-15.9c0-6-2.3-11.7-6.6-15.9l11.6-11.6c7.3,7.3,11.4,17.1,11.4,27.5
                      s-4,20.1-11.4,27.5L233,125.7z"
            />
          </g>
        </g>
        <g>
          <path
            class="no-network-st2 opacityLoop delay2"
            d="M109.3,169.1c-32.7-32.7-32.7-85.9,0-118.5L97.7,39c-18.9,18.9-29.3,44-29.3,70.8
                  c0,26.8,10.4,51.9,29.3,70.8L109.3,169.1z"
          />
          <path
            class="no-network-st2 opacityLoop delay1"
            d="M131,147.4c-20.7-20.7-20.7-54.4,0-75.2l-11.6-11.6c-27.1,27.1-27.1,71.2,0,98.3L131,147.4z"
          />
          <path
            class="no-network-st2 opacityLoop"
            d="M152.7,125.7c-4.2-4.2-6.6-9.9-6.6-15.9c0-6,2.3-11.7,6.6-15.9l-11.6-11.6c-7.3,7.3-11.4,17.1-11.4,27.5
                  s4,20.1,11.4,27.5L152.7,125.7z"
          />
        </g>
      </g>
    </g>
    <g>
      <g>
        <polygon
          class="no-network-st0"
          points="331.6,193.1 323.3,190 328,177 311.2,170.8 303.7,191.6 312,194.7 305.3,213.1 		"
        />
      </g>
    </g>
  </svg>
</div>

<div class="holder no-internet" [class.disconnected]="!searching">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 400 400"
    style="enable-background: new 0 0 400 400"
    xml:space="preserve"
  >
    <style type="text/css">
      .no-network2-st0 {
        fill: #ffffff;
        stroke: #f26522;
        stroke-width: 4;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
      }

      .no-network2-st1 {
        fill: #eec4af;
      }

      .no-network2-st2 {
        fill: #eec4af;
        stroke: #f26522;
        stroke-width: 4;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-miterlimit: 10;
      }
    </style>
    <g>
      <g>
        <g>
          <path
            class="no-network2-st0"
            d="M206.9,20l163.2,282.6c4.4,7.6-1.1,17-9.8,17H33.9c-8.7,0-14.2-9.5-9.8-17L187.3,20
				C191.7,12.4,202.6,12.4,206.9,20z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            class="no-network2-st1"
            d="M240.5,326.4c24.1,13.9,24.3,36.5,0.3,50.5c-24,13.9-63,13.9-87.1,0c-24.2-13.9-24.3-36.5-0.3-50.5
				C177.4,312.4,216.4,312.4,240.5,326.4z"
          />
        </g>
        <g>
          <path
            class="no-network2-st2"
            d="M149.6,344.5c0,7,4.7,14.1,14,19.5c18.6,10.7,48.7,10.7,67.2,0c9.3-5.4,13.9-12.4,13.8-19.5v-13h-95
				L149.6,344.5z"
          />
          <g>
            <path
              class="no-network2-st0"
              d="M230.6,312.1c18.6,10.7,18.7,28.2,0.2,38.9c-18.5,10.7-48.6,10.7-67.2,0c-18.6-10.8-18.7-28.2-0.2-38.9
					C181.9,301.3,212,301.3,230.6,312.1z"
            />
          </g>
        </g>
        <g>
          <path
            class="no-network2-st2"
            d="M164.1,327.2c0,4.9,3.3,9.8,9.8,13.5c12.9,7.5,33.8,7.5,46.7,0c6.4-3.7,9.6-8.6,9.6-13.5v-13h-66
				L164.1,327.2z"
          />
          <g>
            <path
              class="no-network2-st0"
              d="M220.4,300.8c12.9,7.5,13,19.6,0.1,27c-12.8,7.5-33.7,7.5-46.7,0c-12.9-7.5-13-19.6-0.2-27
					C186.5,293.3,207.4,293.3,220.4,300.8z"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          class="no-network2-st2"
          d="M189,313.3c0,1.2,0.8,2.4,2.4,3.3c3.2,1.8,8.3,1.8,11.5,0c1.6-0.9,2.4-2.1,2.4-3.3v-33.9H189L189,313.3z"
        />
      </g>
      <g>
        <g>
          <circle class="no-network2-st2 exclamation" cx="197.1" cy="279.5" r="24.8" />
        </g>
      </g>
      <polygon class="no-network2-st2 exclamation" points="211.3,238.1 218.4,93.5 175.8,93.5 182.9,238.1 	" />
    </g>
  </svg>
</div>
